import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cn from 'classnames';

import './brTabPanel.scss';

export default class BrTab extends Component {
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  onClick = () => {
    const { label, onClick } = this.props;
    onClick(label);
  };

  render() {
    const { activeTab, label, title } = this.props;
    const className = cn('tab-list-item', { 'tab-list-active': activeTab === label });

    return (
      <li className={className} onClick={this.onClick} role="presentation">
        {title || label}
      </li>
    );
  }
}
